import { ConfirmationDialog } from "../../../assets/types/common";
import { FormatHelper } from "../../../assets/utils/helpers/formatHelper";
import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import { LoadingIndicator } from "../../../assets/vfx/loadingIndicator/vfxLoadingIndicator";
import { UserDto } from "../../../services/dto";
import { LookupDto } from "../../../assets/utils/lib/lookupDto";
import DisplayData from "../../common/DisplayData/DisplayData";
import { ViewProps } from "./props";
import Form from "../../../assets/vfx/form/form";
import { ClaimHelper } from "../../../assets/utils/helpers";
import { roles } from "../../../assets/configuration";
interface UserViewProps {
    data: UserDto | undefined;
    show: boolean;
    lookups: ViewProps.UserLookupProps | undefined;
    onHide: () => void;
    onEdit: () => void;
    onDeactivate: () => void;
    onEnableUser?: (values: string, name: string | undefined) => void;
    isLoading: boolean;
}

export const UserView = (props: UserViewProps) => {
    const roleName = LookupDto.getLookupById(props.lookups?.roles, props.data?.roleId)?.display;
    const communityName = LookupDto.getLookupById(props.lookups?.communities, props.data?.communityId)?.display;
    const name: string | undefined = `${props?.data?.firstName} ${props?.data?.lastName}`;

    return (
        <Drawer.View
            className="w-30"
            show={props.show}
            backdrop={true}
            placement="end"
            scroll={true}
            onHide={() => props.onHide()}
            onEdit={props.isLoading ? undefined : props.onEdit}
            title={"View User"}
            onDeactivate={
                (props.isLoading || props.data?.deactivatedDate) ? undefined : props.onDeactivate
            }
            modalDialogProps={
                props.data?.deactivatedDate
                    ? undefined
                    : new ConfirmationDialog().get(props.onDeactivate, "Deactivate", {
                        Name: name ?? Constants.emptyString,
                    })
            }
        >
            {props.isLoading ? (
                <LoadingIndicator isFullPage={true} />
            ) : (
                <>
                    <DisplayData text="First Name" importedData={props.data?.firstName} />
                    <DisplayData text="Last Name" importedData={props.data?.lastName} />
                    {props.data?.email && <DisplayData text="Email" importedData={props.data?.email} />}
                    {roleName && <DisplayData text="Role" importedData={roleName} />}
                    {communityName && <DisplayData text="Community" importedData={communityName} />}
                    {props.data?.activatedDate && <DisplayData
                        text="Activation Date"
                        importedData={
                            props.data?.activatedDate
                                ? FormatHelper.formatDate(props.data?.activatedDate)
                                : Constants.emptyString
                        }
                    />}
                    {props.data?.deactivatedDate && <DisplayData
                        text="De-Activation Date"
                        importedData={
                            props.data?.deactivatedDate
                                ? FormatHelper.formatDate(props.data?.deactivatedDate)
                                : Constants.emptyString
                        }
                    />}
                    {props.data?.status && <DisplayData
                        text="Status"
                        importedData={
                            props.data?.status
                        }
                    />}
                     {
                        ClaimHelper.hasRole([roles.SystemAdmin]) && !props.data?.emailConfirmed &&
                        <Form.Button
                            className="btn btn-primary"
                            type="button"
                                onClick={() => {
                                    props.onEnableUser && props.onEnableUser(props.data?.id!, props.data?.userName);
                                }}
                        >
                            Enable User
                        </Form.Button>
                    }
                </>
            )}
        </Drawer.View>
    );
}